// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"101":"5469f22e4e12b68e","142":"66710957eaa69983","189":"498fea8e8161420a","228":"3e484ed5ead37128","336":"26d165fad8e585c0","730":"50d058f2202000ff","752":"c3d517dd23a95cd9","862":"f77d694958b669b0","962":"c7264290eaa00dc3"}[chunkId] + ".js";
};